function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'earth-brown': 'rgb(116, 41, 12)','antique-grey': 'rgb(174, 147, 115)','cognac': 'rgb(149, 73, 49)','sand': 'rgb(197, 135, 90)','matte-brown': 'rgb(73, 45, 22)','teal-blue': 'rgb(47, 88, 98)','navy-blue': 'rgb(19, 22, 62)','glossy-brown-m-solvspenne': 'rgb(51, 44, 39)','glossy-cognac': 'rgb(150, 68, 43)','taupe': 'rgb(68, 57, 57)','glossybrown': 'rgb(73, 45, 22)','glossy-brown': 'rgb(73, 45, 22)','matteblack': 'rgb(0, 0, 0)','matte-black': 'rgb(0, 0, 0)','red': 'rgb(192, 57, 43)','olive': 'rgb(107, 124, 58)','tan': 'rgb(196, 168, 130)','brown': 'rgb(107, 58, 42)','denim': 'rgb(59, 89, 152)','natural': 'rgb(232, 213, 176)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','farge',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
